export default "__VITE_ASSET__BczDshXa__"